import React from 'react';

export default class MainScore extends React.Component {
    static propTypes = {
        score: React.PropTypes.object
    };

    render() {
        const score = this.props.score;

        if (score === undefined) {
            return false;
        }

        const score1 = score.get('score1') || 0;
        const score2 = score.get('score2') || 0;

        return (<span className="score">
                    {score1 + ':' + score2}
                </span>);
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/MainScore.jsx